import { LabMDM } from "./lab";

export class ProblemDTO {
    _id : string;
    version : number;
    lab : LabMDM;
    category : string;
    problemName : string;
    description : string;
    severity : number;
    extProblemCode : string;
    standardCode : string;
    active : boolean;
}
